import { render } from 'react-dom';
import { OnlineProvider, Header, MedalliaFeedback, UserProfileConsumer } from '@chr/navisphereonline-shared-components';
import { Footer } from '@chr/navisphereonline-shared-components';
import { ChrThemeProvider } from '@chr/eds-react';

import { storeFactory } from './common/utilities/storeFactory';
import { App } from './areas/app/App.component';
import { OnlineTranslationProvider, loadMicrositeLanguage } from '@chr/online-shared-ui-localizations';
import { loadAppConfig } from '@chr/online-shared-microsite-core';
import { LocalConfig } from './common/constants/localConfig';

export const index: Promise<void> = (async () => {
  try {
    const config = await loadAppConfig() as LocalConfig;
    loadMicrositeLanguage();
    const store = storeFactory(config);



    render(
      <OnlineTranslationProvider>
        <OnlineProvider appConfig={config}>
          <ChrThemeProvider>
            <Header />
            <MedalliaFeedback />
            <UserProfileConsumer>
              {(userProfile) => {
                return (
                  <App store={store} config={config} />
                );
              }}
            </UserProfileConsumer>
            <Footer />
          </ChrThemeProvider>
        </OnlineProvider>,
      </OnlineTranslationProvider>,
      document.getElementById('root')
    );
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a polyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (e instanceof Error && e.message.indexOf('Error resolving module') > -1) {
      return;
    }
    console.log(e);
    render(
      <h1>Error loading application</h1>,
      document.getElementById('root'),
    );
  }
})();
